import React from "react";
import House from '../images/House.png'
import Dezign from '../images/Dezign.jpeg'
import Patrick from '../images/Patrick.webp'
import Blog from '../images/Blog.png'
const Projects = () => {
  return (
   <>
   <div className="Paragraph">
      <h1>Projects</h1>
   </div> 
   <div className="Projects">
      <div className="project">
        <a href="https://zhanibekov.github.io/Hata-main/">
          <img src={House} alt='House'/>
          <p>Rentiz</p>
        </a>
      </div>
      <div className="project2">
        <a  href="https://zhanibekov.github.io/Hata-main/">
        <img src={Dezign} alt="House" />
        <p>Dezign</p>
        </a>
      </div>
      <div className="project3">
        <a  href="https://todo-react-tpat.vercel.app/">
        <img src={Patrick} alt="House" />
        <p>To Do List</p>
        </a>
      </div>
      <div className="project4">
        <a  href="https://webapp-frontend-zeta.vercel.app/">
        <img src={Blog} alt="House" />
        <p>Zhanibekov_Blog</p>
        </a>
      </div>
   </div>
   </>
  )
}
export default Projects;